import {t} from "i18next";
import {Trans} from "react-i18next";
import {StatusMessage} from "./StatusMessage";

/**
 * Renders a StatusMessage for common RTK query error shapes (403, 404, generic).
 * Used by ContentPage, ChecklistResource, and HTMLResource.
 */
export const ResourceError = ({error}: {error: unknown}) => {
    const status =
        error && typeof error === "object" && "status" in error
            ? (error as {status: unknown}).status
            : undefined;

    if (status === 403) {
        return (
            <StatusMessage
                title={t("Phrase.NoAccess")}
                detail={<Trans i18nKey="Phrase.SorryYouDoNotHaveAccessToContent" components={{"strong-1": <strong />}} />}
            />
        );
    }

    if (status === 404) {
        return (
            <StatusMessage
                title={t("Error.NotFound")}
                detail={t("Error.404Description")}
            />
        );
    }

    return (
        <StatusMessage
            title={t("Error.SomethingWentWrong")}
            detail={<Trans i18nKey="Error.TryReloadingOrContactUs" components={{"span-1": <span />, "a-1": <a href="#" className="intercom-launcher" />}} />}
        />
    );
};
